// extracted by mini-css-extract-plugin
export var active = "_ab-7";
export var container = "_ab-0";
export var evenWidth = "_ab-4";
export var large = "_ab-5";
export var outlet = "_ab-8";
export var slide = "_ab-2";
export var small = "_ab-6";
export var tab = "_ab-3";
export var tabs = "_ab-1";